import React, { useEffect, useState } from 'react';
import StyledTextfield from './StyledTextfield';
import SettingsIcon from '@mui/icons-material/Settings';
import StyledPopover from './StyledPopover';

const secondaryLabel = {
  fontSize: '12px',
  textAlign: 'center',
  color: '#D9D9D9'
};

const timeSeparator = {
  paddingLeft: '3px',
  paddingRight: '3px'
};

const daysHoursWidth = '80px';

const convertDaysAndHoursAndMinutesToHours = ({ days, hours, minutes }) => {
  const convertedDays = 0;
  const convertedHours = Math.round(days * 24 + hours + minutes / 60);
  const convertedMinutes = 0;
  return { convertedDays, convertedHours, convertedMinutes };
};

function StyledRecordDuration({
  id,
  time,
  mode,
  setMode,
  isDisabled,
  availableModesOptions,
  setAvailableModesOptions,
  setTimeDays = () => {},
  setTimeHours = () => {},
  setTimeMinutes = () => {}
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  useEffect(() => {
    if (mode.value === availableModesOptions[1].value) {
      setDays(time.days);
      setHours(time.hours);
      setMinutes(time.minutes);
    }
    if (mode.value === availableModesOptions[0].value) {
      setDays(convertDaysAndHoursAndMinutesToHours(time).convertedDays);
      setHours(convertDaysAndHoursAndMinutesToHours(time).convertedHours);
      setMinutes(convertDaysAndHoursAndMinutesToHours(time).convertedMinutes);
    }
  }, [mode, time, availableModesOptions]);

  const handlePopover = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <table
      style={{
        color: '#D9D9D9',
        fontSize: '24px',
        borderSpacing: '0px',
        marginTop: '-0.1rem'
      }}
    >
      <tbody>
        <tr>
          <th style={{ minWidth: '30px', textAlign: 'center', verticalAlign: 'bottom' }}>
            {/* <StyledSelect id="units" labelId="units" value={mode} setValue={setMode} optionsList={availableModesOptions}></StyledSelect> */}
            <SettingsIcon style={{ cursor: 'pointer' }} onClick={handlePopover} />
            <StyledPopover
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              availableModesOptions={availableModesOptions}
              mode={mode}
              setMode={setMode}
              setAvailableModesOptions={setAvailableModesOptions}
            />
          </th>
          <th style={timeSeparator}></th>
          <th style={{ width: daysHoursWidth }}>
            <StyledTextfield
              id={id + 'day'}
              type="int"
              value={days}
              minValue={0}
              setValue={setTimeDays}
              isDisabled={isDisabled || mode.value === availableModesOptions[0].value ? true : false}
              disabledcolor={mode.value === availableModesOptions[0].value ? 'lightgrey' : 'black'}
            />
          </th>
          <th style={timeSeparator}>:</th>
          <th style={{ width: daysHoursWidth }}>
            <StyledTextfield
              id={id + 'hour'}
              type="int"
              value={hours}
              minValue={0}
              maxValue={mode.value === availableModesOptions[1].value ? 23 : undefined}
              setValue={setTimeHours}
              isDisabled={isDisabled}
            />
          </th>
          <th style={timeSeparator}>:</th>
          <th style={{ width: daysHoursWidth }}>
            <StyledTextfield
              id={id + 'minute'}
              type="int"
              value={minutes}
              minValue={0}
              maxValue={59}
              setValue={setTimeMinutes}
              isDisabled={isDisabled || mode.value === availableModesOptions[0].value ? true : false}
              disabledcolor={mode.value === availableModesOptions[0].value ? 'lightgrey' : 'black'}
            />
          </th>
        </tr>
        <tr>
          <th style={secondaryLabel}></th>
          <th></th>
          <th style={secondaryLabel}>Days</th>
          <th></th>
          <th style={secondaryLabel}>Hours</th>
          <th></th>
          <th style={secondaryLabel}>Minutes</th>
        </tr>
      </tbody>
    </table>
  );
}
export default StyledRecordDuration;
